import { IFeed } from '@interfaces/feed';
import Link from 'next/link';
import { formatDate } from '@lib/date';
import { TickIcon } from 'src/icons';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { ImageWithFallback } from '@components/common';
import { StarFilled, EuroOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useRouter } from 'next/router';
import { useState } from 'react';
import style from './card-top.module.scss';

const JoinStreamButton = dynamic(() => import('@components/action-buttons/join-live-button'), { ssr: false });
const DropdownActions = dynamic(() => import('./dropdown-actions'));
const ModalTip = dynamic(() => import('@components/performer/tip/modal-tip'), { ssr: false });

interface IProps {
  feed: IFeed;
}

export default function PostTopCard({ feed }: IProps) {
  const user = useSelector((state: any) => state.user.current);
  const { performer } = feed;
  const router = useRouter();
  const [showTipModal, setShowTipModal] = useState(false);

  const handleTip = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user?._id) {
      message.error('Please log in or register!');
      router.push(`/auth/login?redirect=${encodeURIComponent(router.asPath)}`);
      return;
    }
    if (user.isPerformer) {
      message.error('Performers cannot send tips');
      return;
    }
    setShowTipModal(true);
  };

  return (
    <div className={style['feed-top']}>
      <Link href={`/${performer?.username}`}>
        <div className={style['feed-top-left']}>
          <ImageWithFallback
            options={{
              unoptimized: true,
              width: 100,
              height: 100,
              sizes: '(max-width: 767px) 10vw, (min-width: 768px) 5vw'
            }}
            alt="per_atv"
            fallbackSrc="/no-avatar.jpg"
            src={performer?.avatar || '/no-avatar.jpg'}
          />
          <div className={style['feed-name']}>
            <div className={style.name}>
              {performer?.name || 'N/A'}
               &nbsp;
              {performer?.verifiedAccount && <TickIcon />}
              &nbsp;
              {performer?.isFeatured && <StarFilled />}
              &nbsp;&nbsp;
              {performer?.live && <JoinStreamButton feed={feed} user={user} />}
            </div>
            <div className={style.username}>
              @
              {performer?.username || 'n/a'}
              &nbsp;&nbsp;
              <Button
                size="small"
                type="link"
                icon={<EuroOutlined />}
                onClick={handleTip}
                disabled={!user?._id || user?.isPerformer}
                style={{ padding: '0 4px', height: 'auto' }}
              >
                Support Creator
              </Button>
            </div>
          </div>
          <span className={classNames({
            [style['online-status']]: true,
            [style.active]: performer?.isOnline
          })}
          />
        </div>
      </Link>
      <div className={style['feed-top-right']}>
        <span className={style['feed-time']}>{formatDate(feed.createdAt, 'MMM DD')}</span>
        <DropdownActions feed={feed} />
      </div>
      {showTipModal && (
        <ModalTip
          performer={performer}
          open={showTipModal}
          onClose={() => setShowTipModal(false)}
        />
      )}
    </div>
  );
}
